"use strict";
/**
 * Created by Ning Jiang on 4/1/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerEvent = void 0;
class ServerEvent {
}
ServerEvent.INIT_DATA_RECEIVED = "serverEvent_initDataReceived";
ServerEvent.INIT_DATA_PARSED = "serverEvent_initDataParsed";
ServerEvent.GAME_DATA_RECEIVED = "serverEvent_gameDataReceived";
ServerEvent.GAME_DATA_PARSED = "serverEvent_gameDataParsed";
exports.ServerEvent = ServerEvent;
//# sourceMappingURL=ServerEvent.js.map